import { render, staticRenderFns } from "./CouponModal.vue?vue&type=template&id=5a39ddd4&scoped=true&"
import script from "./CouponModal.vue?vue&type=script&lang=ts&"
export * from "./CouponModal.vue?vue&type=script&lang=ts&"
import style0 from "./CouponModal.vue?vue&type=style&index=0&id=5a39ddd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a39ddd4",
  null
  
)

export default component.exports